export const DeadEndFailedFraudChecks = Object.freeze({
  StopList: "STOP_LIST",
  BioStopList: "BIO_STOP_LIST"
});
